import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import clsx from "clsx";
import moment from "moment";
import { Grid, Box, Button } from "@material-ui/core";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";

import useStyles from "../../../themes/makeStyles";
import FormValidationErrorMessage from "../../../components/FormValidationErrorMessage";
import TextField from "../../../components/TextField";
import AutoCompletecontrler from "../../../components/AutoComplete";
import Autocomplete from "../../../components/AutoComplete";
import { default as Apiservices } from "../../../common";
import PickListOptions from "../../../constants/PickListOptions";

export default function FilterForm(props) {
  const classes = useStyles();
  const defaultValues = {
    schemetype: "",
    financial_year: "",
    quarter: "",
    month: "",
    rake_no: "",
    invoice_type: "",
  };
  const methods = useForm({
    mode: "onChange",
    validateCriteriaMode: "all",
    submitFocusError: true,
    defaultValues,
  });

  const [disableDownloadButton, setDisableDownloadButton] = React.useState(
    false
  );
  const [resetvalues, setResetvalues] = React.useState(true);
  const { control, errors, handleSubmit, reset, getValues } = methods;
  const [rakesList, setRakesList] = React.useState([]);
  const [schemeTypeList, setSchemeTypeList] = React.useState([]);
  const [finYearOptions, setFinYearOptions] = useState([]);
  const [currentFinYear, setCurrentFinYear] = useState("");
  const [monthOptions, setMonthOptions] = useState(
    PickListOptions.INVOICE_MONTH_DROPDOWN
  );
  let quarterOptions = PickListOptions.INVOICE_REPORT_QUARTER_DROPDOWN;
  const [isFinHasValue, setIsFinHasValue] = useState(false)

  // set dropdown options
  const setMasterDropdownOptions = async () => {
    const schemetype = methods.getValues("schemetype");
    getActiveRakes(schemetype);
    setSchemeTypeList(PickListOptions.SCHEME_TYPE_OPTIONS);
  };

  const getActiveRakes = async (schemeType) => {
    if (schemeType === "SFTO") {
      let listSftoActiveRakes = [];
      const listSftoRakes = await Apiservices.listSftoActiveRakes();
      listSftoRakes.map((rakeSftoObj) => {
        let listSftoRakeObj = {};
        listSftoRakeObj.value = rakeSftoObj.rake_id;
        listSftoRakeObj.label = rakeSftoObj.rake_name;
        listSftoActiveRakes.push(listSftoRakeObj);
      });
      setRakesList(listSftoActiveRakes);
    } else {
      let listGpwisRakes = [];
      let listGpwisActiveRakes = await Apiservices.listGpwisActiveRakes();
      listGpwisActiveRakes.map((rakeGpwisObj) => {
        let listGpwisRakeObj = {};
        listGpwisRakeObj.value = rakeGpwisObj.rake_id;
        listGpwisRakeObj.label = rakeGpwisObj.rake_name;
        listGpwisRakes.push(listGpwisRakeObj);
      });
      setRakesList(listGpwisRakes);
    }

  }

  // submit filter data
  const onSubmitForm = async (data) => {
    if (
      Object.values(data) &&
      Object.values(data).length > 0 &&
      Object.values(data).some(
        (val) => !(val === null || val === "" || val === undefined)
      )
    ) {
      const body = {
        schemetype: data.schemetype.label ? data.schemetype.label : data.schemetype ? data.schemetype : "SFTO",
        fin_year: data.fin_year ? data.fin_year : null,
        quarter: data.quarter ? data.quarter.value : null,
        month: data.month ? data.month.value : null,
        rake_name: data.rake_name ? data.rake_name.label : null,
        invoice_type: data.invoice_type ? data.invoice_type.label : null
      }
      props.getFilterData(body);
      setDisableDownloadButton(false);
    } else {
      return;
    }
  };

  // generate/download report as excel
  const generateReport = async () => {
    let data = methods.getValues({ nest: true });
    const body = {
      schemetype: data.schemetype.label ? data.schemetype.label : data.schemetype ? data.schemetype : "SFTO",
      fin_year: data.fin_year ? data.fin_year : null,
      quarter: data.quarter ? data.quarter.value : null,
      month: data.month ? data.month.value : null,
      rake_name: data.rake_name ? data.rake_name.label : null,
      invoice_type: data.invoice_type ? data.invoice_type.label : null
    };
    if (body.schemetype === "SFTO") {
      delete body.schemetype;
      Apiservices.downloadSftoInvoiceDetailsReports(body);
    } else {
      delete body.schemetype;
      Apiservices.downloadGpwisInvoiceDetailsReports(body);
    }
    setDisableDownloadButton(true);
  };

  // reset/clear filters 
  const resetForm = () => {
    setResetvalues(!resetvalues);
    methods.reset(defaultValues);
    setDisableDownloadButton(false);
    setTimeout(() => {
      methods.setValue("schemetype", "SFTO");
      props.handleClear();
    }, 100);
  };

  // set financial year options
  const getFinYearDropdown = () => {
    let finYearsArr = [];
    let yearsLength = 5;
    let currentYear = new Date().getFullYear();
    for (let i = 0; i < yearsLength; i++) {
      let next = currentYear + 1;
      let year = currentYear + "-" + next.toString();
      finYearsArr.push(year);
      currentYear--;
    }
    setFinYearOptions(finYearsArr);
    let today = new Date();
    let curMonth = moment(new Date()).format("MM");
    let currentFinYear = "";
    if (Number(curMonth) > 3) {
      var nextYr1 = today.getFullYear() + 1;
      currentFinYear = today.getFullYear() + "-" + nextYr1;
    } else {
      var nextYr2 = today.getFullYear();
      currentFinYear = today.getFullYear() - 1 + "-" + nextYr2;
    }
    setCurrentFinYear(currentFinYear);
  };

  useEffect(() => {
    methods.setValue("schemetype", "SFTO");
    getFinYearDropdown();
    const fetchData = async () => {
      await setMasterDropdownOptions();
    };
    fetchData();
  }, []);

  // change quarter options
  const handleQuarterChange = (selectedQuarter) => {
    if (selectedQuarter !== null) {
      const findMonths = quarterOptions.find(
        (ele) => ele.value === selectedQuarter.value
      );
      setMonthOptions(findMonths.months);
      methods.setValue("month", "");
    } else {
      setMonthOptions(PickListOptions.INVOICE_MONTH_DROPDOWN);
      methods.setValue("month", "");
    }
  };


  return (
    <>
      <form
        noValidate
        id="filter-form"
        onSubmit={handleSubmit(onSubmitForm)}
        key={resetvalues}
      >
        <Grid container spacing={2}>
          <Grid item container spacing={2}>
            <Grid item xs={12} sm={3}>
              <Autocomplete
                name="schemetype"
                control={control}
                Values={schemeTypeList}
                disabled={false}
                label="Scheme Type"
                getValueChanged={(data) => {
                  methods.setValue("rake_name", "");
                  if (data === null) {
                    getActiveRakes("SFTO");
                  } else {
                    getActiveRakes(data.value);
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <AutoCompletecontrler
                control={control}
                name="fin_year"
                id="fin_year"
                defaultValue={currentFinYear}
                Values={finYearOptions}
                disabled={false}
                label="Financial Year"
                fullWidth
                getValueChanged={(data) => {
                  if (data !== null) {
                    setIsFinHasValue(true);
                  } else {
                    setIsFinHasValue(false);
                    methods.setValue("month", "");
                    methods.setValue("quarter", "");
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <Autocomplete
                name="quarter"
                id="quarter"
                control={control}
                Values={quarterOptions}
                rules={{ required: false }}
                required={false}
                label="Quarter"
                getValueChanged={handleQuarterChange}
                disabled={!isFinHasValue}
                error={errors.rake_name}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <Autocomplete
                name="month"
                id="month"
                control={control}
                Values={monthOptions}
                rules={{ required: false }}
                required={false}
                label="Month"
                disabled={!isFinHasValue}
                error={errors.month}
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <Autocomplete
                name="rake_name"
                id="rake_name"
                control={control}
                Values={rakesList}
                disabled={false}
                label="Rake Name"
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <Autocomplete
                name="invoice_type"
                id="invoice_type"
                control={control}
                Values={PickListOptions.SERVICE_TYPE_OPTIONS}
                rules={{ required: false }}
                required={false}
                label="Invoice Type"
              />
            </Grid>
          </Grid>
        </Grid>

        <Box py={2}>
          <Grid container direction="row" justify="space-between">
            <Grid item></Grid>
            <Grid item>
              <Grid container spacing={1} justify="flex-end">
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    className={clsx(classes.subTextButton)}
                    type="button"
                    onClick={generateReport}
                    startIcon={<CloudDownloadIcon />}
                    disabled={disableDownloadButton}
                  >
                    Export to Excel
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    id="SearchIcon"
                    className={classes.subTextButton}
                    type="submit"
                  // onClick={handleFilterSearch}
                  >
                    Submit
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="outlined"
                    disabled={false}
                    className={clsx(classes.subTextButton, "btnMinWidthSearch")}
                    onClick={resetForm}
                  >
                    Clear
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </form>
    </>
  );
}
